/*
 * Copyright (c) 2018. CPP, Inc. All rights reserved.
 * Also protected by Patent Pending: 15/916,593
 */
import { flattenQuery, mkEmptyData } from './helpers'
import processApp from './appData'
import processCoordinates from './coordinateData'
import processLawsonData from './lawsonData'
import processPlots from './plotData'
import processSettings from './settingsData'
import processSummaries from './summaryData'

function processReportData(rawQuery) {
  const query = flattenQuery(rawQuery)
  const locIds = query.coordinates.map(e => e.location)

  const processedData = mkEmptyData(locIds)
  console.log(processedData)
  processApp(processedData, query.app, query.site)
  processSettings(processedData, query.settings)
  processCoordinates(processedData, query.coordinates)
  processSummaries(processedData, query.summaries)
  processPlots(processedData, query.plots)
  processLawsonData(processedData, query.ratings)
  return processedData
}

export default processReportData
